import type { TrackingEvents, TrackingEventsAdditionalData } from "@jti/tracker";

export interface SelectItemTrackingParams {
  title: string;
  dataSku?: string;
  currentPrice?: number;
  currency?: string;
  discount?: number;
  colors?: string[];
  colorLabels?: string[];
  primaryButtonText?: string;
  isBundle?: boolean;
  categoryName?: string;
}

export const buildProductCardSelectItemData = ({
  title,
  dataSku,
  currentPrice,
  currency,
  discount,
  colors,
  colorLabels,
  primaryButtonText,
  isBundle,
  categoryName,
}: SelectItemTrackingParams): TrackingEventsAdditionalData[TrackingEvents.TrackingSelectItem] => {
  // Fallback chain for item_name: title -> SKU -> CTA text -> N/A
  const itemName = title || dataSku || primaryButtonText || "N/A";
  const itemId = dataSku || title;

  const purchaseType = isBundle ? "bundle" : "N/A";

  return {
    currency: currency ?? "N/A",
    value: currentPrice ?? "N/A",
    ecommerce: {
      items: [
        {
          item_id: itemId,
          item_sku: dataSku ?? "N/A",
          item_name: itemName,
          price: currentPrice ?? "N/A",
          currency: currency ?? "N/A",
          discount: discount ?? 0,
          quantity: 1,
          index: 0,
          item_brand: "N/A",
          item_category: categoryName || "N/A",
          item_category2: "N/A",
          item_color: colorLabels?.[0] || colors?.[0] || "N/A",
          item_flavor: "N/A",
          item_strength: "N/A",
          item_coupon: "N/A",
          item_coupon_type: "N/A",
          item_list_id: "N/A",
          item_list_name: "N/A",
          item_rewards: "N/A",
          purchase_type: purchaseType,
          carton_format: "N/A",
          carton_quantity: "N/A",
        },
      ],
    },
  };
};
